import React, { FunctionComponent } from 'react';
import { Grid, Card, Placeholder } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  card: {
    minHeight: '11.875rem !important',
    width: '100% !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    borderRight: '.062r5em  solid #f7f7f7 !important',
    transform: 'none !important',
  },
  header: {
    padding: '1em !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    color: '#440C7F !important',
    fontWeight: 'bold' as const,
  },
  cnCard: {
    padding: '0 !important',
    margin: '0 .75rem !important',
    '&:first-child': {
      marginLeft: '0 !important',
    },
    '&:last-child': {
      marginRight: '0 !important',
    },
  },
  description: {
    padding: '1em !important',
  },
  gridRow: {
    margin: '0 !important',
    padding: '.5rem 0 !important',
  },
};

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const renderRow = (classes: Styles) => (
  <Grid.Row className={classes.gridRow}>
    <Grid.Column width={4}>
      <Placeholder>
        <Placeholder.Line />
      </Placeholder>
    </Grid.Column>
    <Grid.Column width={12}>
      <Placeholder>
        <Placeholder.Line />
      </Placeholder>
    </Grid.Column>
  </Grid.Row>
);

const CNStatusCardsPlaceholder: FunctionComponent<Props> = ({ classes }) => (
  <Grid.Column className={classes.cnCard}>
    <Card className={classes.card}>
      <Card.Header className={classes.header}>
        <Placeholder>
          <Placeholder.Header image>
            <Placeholder.Line />
          </Placeholder.Header>
        </Placeholder>
      </Card.Header>
      <Card.Description className={classes.description}>
        <Grid>
          {renderRow(classes)}
          {renderRow(classes)}
          {renderRow(classes)}
        </Grid>
      </Card.Description>
    </Card>
  </Grid.Column>
);

export default withStyles(styles)(CNStatusCardsPlaceholder);
